module.exports = __webpack_public_path__ + "img/t4.02feadb7.png";